import React from 'react';
import { saveData } from "services/api/saveData";

export const handleSetToSchedule = async ({
    itemId,
    setFloatingAlert,
    setButtonLoader,
    buttonAction,
    fetchData
}: {
    itemId: number;
    setFloatingAlert: Function;
    setButtonLoader: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
    buttonAction: string;
    fetchData?: () => void,
}) => {

    try {
        // Start the button loader
        setButtonLoader((prev) => ({ ...prev, [buttonAction]: true }));

        // Create the new job
        const response = await saveData({
            apiUrl: `job_to_schedule/${itemId}`,
            method: 'patch',
            data: {}
        });

        // Handle succesful response
        if (response && response.status === 200) {
            setFloatingAlert({
                type: 'success',
                message: 'validation.job.set_to_scheduled',
            });

            // Refresh the modal data
            if (fetchData) {
                await fetchData();
            }
        }
    } catch (error) {
        setFloatingAlert({
            type: 'danger',
            message: 'validation.general.save_failed',
        });
    } finally {
        // Stop the button loader
        setButtonLoader((prev) => ({ ...prev, [buttonAction]: false }));
    }
};